<template>
  <div class="mt-4">
    <h6>Insira sua Chave de Segurança</h6>
    <p style="opacity: 0.7">
      Clique no botão abaixo para verificar sua identidade com a chave de
      segurança.
    </p>
    <div v-if="!options && loading">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else>
      <b>Autenticadores disponíveis:</b>
      <ul class="py-4 text-start">
        <li v-for="option in options.authenticators" :key="option.id">
          {{ option.name }}
        </li>
      </ul>
      <v-alert v-if="error" type="error">{{ error }}</v-alert>
      <v-btn
        color="primary"
        block
        @click="submitToken"
        :loading="loading"
        :disabled="loading"
      >
        Verificar
      </v-btn>
    </div>
  </div>
</template>

<script>
import AUTH from "@/services/auth";
import { mapActions } from "vuex";

export default {
  metaInfo: {
    script: [
      {
        src: "https://cdn.jsdelivr.net/npm/@simplewebauthn/browser@10.0.0/dist/bundle/index.umd.min.js",
        async: true,
      },
    ],
  },
  data: () => ({
    loading: false,
    error: null,
    options: null,
  }),
  methods: {
    ...mapActions("auth", ["setLogin"]),
    async getOptions() {
      this.loading = true;
      this.error = null;
      try {
        const response = await AUTH.twoFAVerify(this.token, {
          type: "WEBAUTHN",
          data: {},
        });
        this.options = response;
      } catch (error) {
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    },
    async submitToken() {
      this.loading = true;
      this.error = null;
      try {
        const { startAuthentication } = SimpleWebAuthnBrowser;

        const { options } = this.options;
        const credential = await startAuthentication(options);

        const response = await AUTH.twoFAVerify(this.token, {
          type: "WEBAUTHN",
          data: { credential },
        });
        this.setLogin(response);
        this.$emit("success");
      } catch (error) {
        this.error = error.message;
        this.loading = false;
      }
    },
  },
  watch: {},
  mounted() {
    this.getOptions();
  },
  props: {
    token: {
      type: String,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style>
</style>